var _path, _ellipse, _ellipse2, _path2, _ellipse3, _ellipse4, _path3, _ellipse5, _ellipse6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M6 22h2v10H6z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 27,
    rx: 3,
    ry: 5,
    fill: "#919191"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 27,
    rx: 3,
    ry: 5,
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M34 22h2v10h-2z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36,
    cy: 27,
    rx: 3,
    ry: 5,
    fill: "#595959"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 27,
    rx: 3,
    ry: 5,
    fill: "gray"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M22 22h2v10h-2z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 27,
    rx: 3,
    ry: 5,
    fill: "#919191"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 27,
    rx: 3,
    ry: 5,
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H0v20h31V0z",
    fill: "#E8B961"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H16v20h15V0z",
    fill: "#958566"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H9v4h5V2z",
    fill: "#F4F4F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27h21V17L38.404 3H23v24z",
    fill: "#6BCEF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27h21V16.5L35.404 3H20v24z",
    fill: "#90DAFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17H29v10h15V17z",
    fill: "#EC7C4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 27H0v-7h17V3h6.404L29 17v10z",
    fill: "#E54500"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M29 23h15v2H29z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M32 23h9v2h-9z"
  })));
}

export default SvgIconVehicle;